<template>
  <div class="container-fluid">
    <div class="loading" v-if="loading">Loading&hellip;</div>

    <div class="view-header my-4">
      <div class="view-header__main">
        <div class="view-header__info">
          <h1 class="view-header__title">Categorías de cajas</h1>
          <p class="view-header__subtitle">Categorías que clasifican los movimientos de cajas y cuentas bancarias.</p>
        </div>
        <div class="view-header__actions">
          <button type="button" class="btn view-header__btn view-header__btn--primary" @click="openNewCategory">
            <i class="bi bi-plus-lg"></i>
            Nueva categoría
          </button>
        </div>
      </div>
    </div>

    <!-- FILTROS -->
    <div class="filters-panel">
      <div class="filters-panel__section">
        <div class="filters-panel__row">
          <div class="filters-panel__field">
            <input v-model="doSearch" type="search" class="form-control" placeholder="Buscar categoría...">
          </div>
        </div>
      </div>
    </div>

    <!-- TABLA -->
    <div class="data-table">
      <vdtnet-table
        ref="table"
        :fields="fields"
        :opts="opts"
        :selectCheckbox="0"
        container-class-name="table-responsive"
        class-name="table mb-0"
        @edit="changeFundCategoryId"
        @delete="deleteFundCategory"
      />
    </div>

    <!-- MODAL NUEVA / EDITAR CATEGORÍA -->
    <transition name="modal">
      <div v-if="showCategoryModal" class="modal-mask-product">
        <div class="modal-dialog modal-lg">
          <div class="modal-content">
            <div class="form-card__header">
              <h6 class="form-card__title">
                <i :class="fundCategoryIdParent == null ? 'bi bi-plus-lg' : 'bi bi-pencil'"></i>
                {{ fundCategoryIdParent == null ? 'Nueva categoría' : 'Editar categoría' }}
              </h6>
              <button type="button" class="form-card__btn" @click="closeCategoryModal">
                <i class="bi bi-x-lg"></i>
              </button>
            </div>
            <div class="modal-body">
              <NuevaCategoriaCaja
                :fundCategoryId="fundCategoryIdParent"
                @reset-id="fundCategoryIdParent = null"
                @confirmsave="onCategorySaved"
                @close="closeCategoryModal"
              />
            </div>
          </div>
        </div>
      </div>
    </transition>
  </div>
</template>

<script>
import NuevaCategoriaCaja from "./../sub-components/Nueva-categoria-caja.vue";
import VdtnetTable from '@/components/global/VdtnetTable.vue';

export default {
  components: {
    NuevaCategoriaCaja,
    VdtnetTable,
  },
  data: function () {
    return {
      doSearch: "",
      loading: false,
      fundCategoryIdParent: null,
      showCategoryModal: false,
      opts: {
        language: {
          url: '//cdn.datatables.net/plug-ins/1.13.4/i18n/es-ES.json',
        },
        ajax: {
          url: process.env.VUE_APP_BASE_URL + "/api/fundsCategories/list",
          type: "GET",
          headers: { Authorization: "Bearer " + localStorage.getItem("token") },
        },
        autoWidth: false,
        pageLength: 15,
        searching: true,
      },
      fields: {
        name: {
          label: "Nombre",
          searchable: true,
          render: (data, type) =>
            type === 'display' ? `<span class="data-table__primary">${data}</span>` : data,
        },
        description: { label: "Descripción", searchable: true },
        type: {
          label: "Tipo",
          searchable: true,
          render: (data, type) => {
            if (type !== 'display') return data;
            if (data === 'in') return '<span class="status-badge status-badge--success">Ingreso</span>';
            if (data === 'out') return '<span class="status-badge status-badge--danger">Egreso</span>';
            return data || '';
          },
        },
        actions: {
          isLocal: true,
          label: "Acciones",
          width: "100px",
          align: "right",
          orderable: false,
          searchable: false,
          render: (_data, _type, row) => {
            if (!row.action) return '';
            return `
              <div class="table-action-group">
                <button data-action="edit" class="table-action-btn" type="button" title="Editar">
                  <i class="bi bi-pencil"></i>
                </button>
                <button data-action="delete" class="table-action-btn" type="button" title="Borrar">
                  <i class="bi bi-trash"></i>
                </button>
              </div>
            `;
          },
        },
      },
    };
  },
  watch: {
    doSearch(newValue, oldValue) {
      if (newValue.length >= 4 || oldValue.length >= 4) {
        this.$refs.table.search(this.doSearch);
      }
      if (newValue === "" && oldValue.length > 0) {
        this.$refs.table.search(this.doSearch);
      }
    },
  },
  mounted() {
    this.$nextTick(() => {
      const dt = this.$refs.table && this.$refs.table.dataTable;
      if (!dt) return;
      dt.on('preXhr.dt', () => { this.loading = true; });
      dt.on('xhr.dt', () => { this.loading = false; });
    });
  },
  methods: {
    refreshTable() {
      if (this.$refs.table !== undefined) this.$refs.table.reload();
    },
    openNewCategory() {
      this.fundCategoryIdParent = null;
      this.showCategoryModal = true;
    },
    changeFundCategoryId(data) {
      this.fundCategoryIdParent = data.id;
      this.showCategoryModal = true;
    },
    closeCategoryModal() {
      this.showCategoryModal = false;
      this.fundCategoryIdParent = null;
    },
    onCategorySaved() {
      this.closeCategoryModal();
      this.refreshTable();
    },
    deleteFundCategory(data) {
      if (!confirm("¿Está seguro que desea borrar esta categoría de caja?")) return;
      this.$http.post("/api/fundsCategories/delete", { id: data.id }).then((response) => {
        if (response.data.code == 200) {
          this.refreshTable();
        }
      });
    },
  },
};
</script>

<style scoped>
.modal-mask-product {
  position: fixed;
  z-index: 1050;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(16, 24, 40, 0.45);
  display: flex;
  align-items: flex-start;
  justify-content: center;
  padding: 24px;
  overflow-y: auto;
}

.modal-dialog {
  margin: 0;
  width: 100%;
  max-width: 560px;
}

.modal-content {
  border: 1px solid var(--border-soft);
  border-radius: 12px;
  box-shadow: 0 12px 32px rgba(16, 24, 40, 0.18);
  overflow: hidden;
  background: var(--surface);
}

.modal-body {
  max-height: 80vh;
  overflow-y: auto;
  padding: 0;
}

.modal-enter,
.modal-leave-active {
  opacity: 0;
}

.modal-enter .modal-content,
.modal-leave-active .modal-content {
  transform: scale(1.02);
}
</style>
